import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY // Keep this secret and do not expose it in frontend

// Encrypt and store data
export const storeEncryptedData = (key, value) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
  localStorage.setItem(key, encryptedData);
};

// Retrieve and decrypt data
export const getDecryptedData = (key) => {
  const encryptedData = localStorage.getItem(key);
  if (!encryptedData) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

// Remove data securely
export const removeStoredData = (key) => {
  localStorage.removeItem(key);
};



// import CryptoJS from "crypto-js";

// const SECRET_KEY = "nextfutureai123456"; // Do NOT expose this key in frontend

// // Encrypt and store data
// export const storeEncryptedData = (key, value) => {
//   if (!value) {
//     console.error("Value is null or undefined, cannot store.");
//     return;
//   }
  
//   console.log("Before Encryption:", JSON.stringify(value));
  
//   const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), SECRET_KEY).toString();
  
//   console.log("Encrypted Data:", encryptedData);
  
//   localStorage.setItem(key, encryptedData);
// };

// // Retrieve and decrypt data
// export const getDecryptedData = (key) => {
//   const encryptedData = localStorage.getItem(key);
//   if (!encryptedData) {
//     console.error("No data found in localStorage for key:", key);
//     return null;
//   }

//   try {
//     console.log("Stored Encrypted Data:", encryptedData);
    
//     const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    
//     console.log("Decrypted Bytes:", bytes.toString(CryptoJS.enc.Utf8));

//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//   } catch (error) {
//     console.error("Error decrypting data:", error);
//     return null;
//   }
// };

// // Remove data securely
// export const removeStoredData = (key) => {
//   localStorage.removeItem(key);
// };
